import FieldColorAutocomplete from './FieldColorAutocomplete'

export default FieldColorAutocomplete
